/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-09-27 15:37:11
 * @LastEditTime: 2020-09-28 11:05:32
 * @Description: 销售记录store
 */
import {
    getSalesRecordByID,
    getSalesRecordList,
    updateSalesRecord,
    createSalesRecord,
    getSalesRecordTags
} from '@/api/salesRecord'
import Vue from 'vue'

const state = {
    salesRecordList: [],
    salesRecordTags: [],
    totalCounts: 0
}

const actions = {
    async getSalesRecordListAction({
        commit
    }, payload) {
        try {
            const salesRecordList = await getSalesRecordList(payload);
            commit('SETSALESRECORDLIST', salesRecordList.data)
        } catch (error) {
            throw error.message
        }
    },

    // 获取标签并间接修改
    async getSalesRecordTagsAction({
        commit
    }, payload) {
        try {
            const res = await getSalesRecordTags(payload)
            commit('SETSALESRECORDTAGS', res.data);
            return res.data.tags
        } catch (error) {
            throw error
        }
    },
    async getSalesRecordByIDAction({
        commit
    }, payload) {
        try {
            const salesRecord = await getSalesRecordByID(payload)
            return salesRecord.data
        } catch (error) {
            throw error.message
        }
    },
    async createSalesRecordAction({
        commit
    }, payload) {
        try {
            const salesRecord = await createSalesRecord(payload);
            commit('ADDSALESRECORD', salesRecord.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesRecordAction({
        commit
    }, payload) {
        try {
            const salesRecord = await updateSalesRecord(payload.id, payload.data)
            commit('UPDATESALESRECORD', salesRecord.data)
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETSALESRECORDLIST(state, payload) {
        state.salesRecordList = payload.salesRecordList;
        state.totalCounts = payload.totalCounts
    },
    // 设置销售标签属性
    SETSALESRECORDTAGS(state, payload) {
        state.salesRecordTags = payload.tags;
    },
    ADDSALESRECORD(state, salesRecord) {
        state.salesRecordList.unshift(salesRecord)
        state.totalCounts++
    },
    UPDATESALESRECORD(state, salesRecord) {
        Vue.set(state.salesRecordList, state.salesRecordList.findIndex(x => x._id === salesRecord._id), salesRecord)
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}